/*
* Filters on template page "collection family"
*/
let $filtersButton = document.querySelector('.collection-family__filters');
let $filters = document.querySelector('.filters-collections');
let $closeIcon = document.querySelector('.filters-collections__close .close-icon'); //Open filters

$filtersButton.addEventListener('click', function () {
  $filters.classList.add('active');
}); //Close filters

$closeIcon.addEventListener('click', function () {
  $filters.classList.remove('active');
}); //Close filters on click on a link

let $linksFilters = document.querySelectorAll('.filters-collections__item');
$linksFilters.forEach(function (link) {
  link.addEventListener('click', function () {
    $filters.classList.remove('active');
  });
}); //Sticky filters

let $stickyFiltersTrigger = document.querySelector('.collection-family__page-content'); //Element from which we want to show the sticky filters

let $stickyFilters = document.querySelector('.sticky-filters'); // sticky filters element
// Top position between the top of the document and the element $stickyFiltersTrigger

let triggerPositionY = $stickyFiltersTrigger.getBoundingClientRect().top + window.scrollY; //Event on sccroll

window.addEventListener('scroll', function () {
  if (window.scrollY > triggerPositionY) {
    $stickyFilters.classList.add('active');
  } else {
    $stickyFilters.classList.remove('active');
  }
}); //console.log($heightPositionTopFilters);